// Registry menu host hiện tại — AppLayout (nhận `menu` prop từ app) set khi
// render, page khác (vd /permissions) get để hiển thị ĐÚNG theo menu thật của
// app mình (SaaS NAV_GROUPS vs Core adminMenu khác nhau). Tránh hardcode +
// drift. Module-level (không React state) — AppLayout render TRƯỚC page con nên
// page đọc được giá trị mới nhất.
let _menu = [];

export function setHostMenu(m) {
  _menu = Array.isArray(m) ? m : [];
}

export function getHostMenu() {
  return _menu;
}
